import {all} from "redux-saga/effects";
//public
import LayoutSaga from "./layout/saga";
import RegisterSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import MfaSaga from "./auth/mfa/saga";
import UserSaga from "./auth/user/saga";
import CartSaga from "./cart/saga";
import InfoSaga from "./info/saga";
import variablesSaga from "./auth/variables/saga";
import tokenSagas from "./auth/tokens/saga";

export default function* rootSaga() {
    yield all([
        //public
        LayoutSaga(),
        RegisterSaga(),
        AuthSaga(),
        ForgetSaga(),
        MfaSaga(),
        UserSaga(),
        CartSaga(),
        InfoSaga(),
        variablesSaga(),
        tokenSagas()
    ]);
}